<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="1"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "logoType",
    data() {
        return {
            selectedImage: '',
            img: [
                {id:'1',name:'انتزاعی',value:'abstract',full_path:require('../../../../public/media/site/logoType/انتزاعی.png')},
                {id:'1',name:'تایپوگرافی',value:'typography',full_path:require('../../../../public/media/site/logoType/تایپوگرافی.png')},
                {id:'1',name:'تصویری',value:'visual',full_path:require('../../../../public/media/site/logoType/تصویری.png')},
                {id:'1',name:'تلفیقی',value:'combined',full_path:require('../../../../public/media/site/logoType/تلفیقی.png')},
                {id:'1',name:'سه بعدی',value:'three-dimensional',full_path:require('../../../../public/media/site/سه بعدی2.png')},
                {id:'1',name:'مسکات',value:'muscat',full_path:require('../../../../public/media/site/logoType/مسکات.png')},
                {id:'1',name:'مونوگرام',value:'monogram',full_path:require('../../../../public/media/site/logoType/مونوگرام1.png')},
                {id:'1',name:'مینیمال',value:'minimal',full_path:require('../../../../public/media/site/logoType/مینیمال.png')},
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"logoType")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>